/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeriesDate/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Simple/Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function ImageSeriesDate({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Edit/EditModal/Content/ImageSeriesDate"
  
}) {
let constantData = 'Series:'
let patientImageImageseriesSeriesDateValueData = fromData.useDataFormat({ viewPath,
context: 'patient_image',
path: 'imageseries.series_date',
format: fromFormat.dateISOIn,
})
let aggregateData = fromAggregate.join(constantData, patientImageImageseriesSeriesDateValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginLeft={dtSpaceS}
 data="'Series:'"
 data="patient_image.imageseries.series_date"
 format="/Simple/Data/format.js dateISOIn"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}